import { ScheduleProp } from '@wetags/schedule';
import { useScheduleRequestFeaturesAccess } from './use-schedule-request-features-access';

// TODO: Replace the wetag with customization flag, when decided by product
// When CF is available, add it to useScheduleRequestFeaturesAccess condition to show requests when enabled
export const usePartnerScheduleRequestsAccess = (locationId: string | undefined) => {
  const [isPartnerScheduleRequestWetagEnabled, isLoadingPartnerScheduleRequestWetag] = ScheduleProp.useWetag(
    'partner-schedule-requests',
    locationId
  );

  const { hasScheduleRequestFeaturesAccess, isLoading: isLoadingScheduleRequestAccess } =
    useScheduleRequestFeaturesAccess();

  const isEnabled = hasScheduleRequestFeaturesAccess && isPartnerScheduleRequestWetagEnabled;
  const isLoading = isLoadingScheduleRequestAccess || isLoadingPartnerScheduleRequestWetag;

  return {
    hasPartnerScheduleRequestsAccess: !isLoading && isEnabled,
    isLoading,
  };
};
